import angular from 'angular';
import uiRouter from 'angular-ui-router';
import actionLinkComponent from './actionLink.component';

let actionLinkModule = angular.module('actionLink', [
  uiRouter
])

.component('actionLink', actionLinkComponent)

.name;

export default actionLinkModule;
